/**
 * @fileoverview Link "pular para o conteúdo" para acessibilidade.
 *
 * Visualmente oculto (sr-only) até receber foco via Tab.
 * Permite que usuários de teclado e leitores de tela pulem
 * direto para o conteúdo principal (#main-content).
 */
export default function SkipLink() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[9999] focus:px-4 focus:py-2 focus:rounded-md focus:bg-secondary focus:text-secondary-foreground focus:outline-none focus:ring-2 focus:ring-ring"
    >
      Pular para o conteúdo principal
    </a>
  );
}
